import {
  Icon,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@elaniintc/goes-design-system";

import type { VariableSelectorProps } from "./types";
import { getTypeIcon, getTypeRepresentation } from "./utils";


export const VariableSelector = ({
  variables,
  selectedVariable,
  onSelectVariable,
  triggerGroup: group,
  placeholder = "Seleccione una variable",
}: VariableSelectorProps) => {
  return (
    <Select
      onValueChange={(val) => {
        const variable = variables.find((v) => v.id === val);
        onSelectVariable(variable || null);
      }}
      value={selectedVariable?.id || ""}
    >
      <SelectTrigger className="min-w-0 w-full flex" group={group}>
        <div className="w-full flex gap-3 items-center">
          {selectedVariable && (
            <Icon type="far" name={getTypeIcon(selectedVariable.type)} />
          )}
          <p className="truncate text-body">
            {selectedVariable?.name ?? placeholder}
          </p>
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-[440px] overflow-y-auto border border-neutral py-2">
        {variables.length === 0 && (
          <div className="h-full w-full flex items-center justify-center text-body-quiet">
            No hay variables disponibles
          </div>
        )}
        {variables.map((variable) => (
          <SelectItem
            key={`${variable.id}-${variable.name}`}
            value={variable.id}
          >
            <div className="w-full flex items-center gap-3">
              <Icon type="far" name={getTypeIcon(variable.type)} />
              <div className="gap-2 items-center">
                <div className="text-body font-semibold">{variable.name}</div>
                <div className="text-body-quiet text-sm">
                  {getTypeRepresentation(variable.type)}
                </div>
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
